import { combineReducers } from '@reduxjs/toolkit';
import { LOCATION_CHANGE } from 'react-router-redux';
import { createResponsiveStateReducer } from 'redux-responsive';

import oauthReducer from 'containers/OAuthApp/reducer';
import globalReducer from './containers/App/reducer';
import portalReducer from './containers/PortalApp/reducer';
import frontReducer from './containers/LoginApp/reducer';
import CardDetailControl from './containers/CardDetailControl/reducer';
import languageProviderReducer from './containers/LanguageProvider/reducer';
import reLoginReducer from './containers/ReLogin/reducer';
import { officeApi } from './services/office';

const routeInitialState = {
  locationBeforeTransitions: null
};

/**
 * Merge route into the global application state
 */
function routeReducer(state = routeInitialState, action) {
  switch (action.type) {
    /* istanbul ignore next */
    case LOCATION_CHANGE:
      return { ...state, locationBeforeTransitions: action.payload };
    default:
      return state;
  }
}

/**
 * Creates the main reducer with the asynchronously loaded ones
 */

const createRootReducer = (asyncReducers) => {
  const appReducer = combineReducers({
    route: routeReducer,
    global: globalReducer,
    portalApp: portalReducer,
    loginApp: frontReducer,
    oauthApp: oauthReducer,
    cardDetailControl: CardDetailControl,
    language: languageProviderReducer,
    reLogin: reLoginReducer,
    [officeApi.reducerPath]: officeApi.reducer,
    ...asyncReducers,
    browser: createResponsiveStateReducer({
      xs: 544,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 10000,
      extraFields: () => ({
        width: window.innerWidth
      })
    })
  });
  return (state, action) => {
    if (action.type === 'LOGOUT_USER') {
      return appReducer(undefined, action);
    }
    return appReducer(state, action);
  };
};

export default createRootReducer;
